import { useEffect, useLayoutEffect, useRef } from "react";

// How long the mark waits for a move that never comes (the sidebar already
// where it was asked to be).
const INSTANT_MS = 400;

// An open investigation has the page to itself: the sidebar folds while one is
// up (the `origin-investigation-workspace` event, true) and comes back as it was
// once none is (false). Either move happens at once (styles.css,
// [data-nav-instant]): the sidebar's slide, the column over the page before
// the page steps aside, reads as the page hiding under it when nobody asked
// for it. The app shell and the lanes harness both use this.
export function useInvestigationSidebarFold(collapsed, setCollapsed) {
  const before = useRef(null);
  const instant = useRef(null);
  const letGo = () => {
    clearTimeout(instant.current);
    instant.current = null;
    delete document.documentElement.dataset.navInstant;
  };
  useEffect(() => {
    const atOnce = () => {
      document.documentElement.dataset.navInstant = "";
      clearTimeout(instant.current);
      instant.current = setTimeout(letGo, INSTANT_MS);
    };
    const onWorkspace = (event) => {
      if (event.detail) {
        atOnce();
        setCollapsed((current) => { if (before.current === null) before.current = current; return true; });
      } else if (before.current !== null) {
        atOnce();
        setCollapsed(before.current);
        before.current = null;
      }
    };
    window.addEventListener("origin-investigation-workspace", onWorkspace);
    return () => {
      window.removeEventListener("origin-investigation-workspace", onWorkspace);
      letGo();
    };
  }, [setCollapsed]);
  // The move drawn with no transition (reading layout makes the browser apply
  // it now), the mark is let go before the next paint.
  useLayoutEffect(() => {
    if (!instant.current) return;
    void document.documentElement.offsetWidth;
    letGo();
  }, [collapsed]);
}
